import { render, staticRenderFns } from "./WPBaseTextfield.vue?vue&type=template&id=09c88502"
import script from "./WPBaseTextfield.vue?vue&type=script&lang=ts"
export * from "./WPBaseTextfield.vue?vue&type=script&lang=ts"
import style0 from "./WPBaseTextfield.vue?vue&type=style&index=0&id=09c88502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports